










































































import InputMoney from '@/components/UI/input-money.vue';
import FormatUtils from '@/helpers/formatUtils';
import Component from 'vue-class-component';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';

@Component({
  components: { InputMoney },
  directives: {
    currency: CurrencyDirective
  }
})
export default class ProductTpPatient extends BaseComponent {
  @Prop()
  value: any;

  dto: any = {};

  maskPeso = {
    currency: { prefix: '', suffix: '' },
    locale: 'pt-BR',
    precision: { min: 0, max: 3 }
  };

  @Watch('value', { immediate: true })
  onValueChange(v) {
    if (!v) {
      this.dto = {};
      return;
    }
    let dto = { ...v };
    dto.pesoMin = v.pesoMin ? this.getMaskedValue(v.pesoMin) : null;
    dto.pesoMax = v.pesoMax ? this.getMaskedValue(v.pesoMax) : null;
    this.dto = dto;
  }

  getDescriptionWeight() {
    if (!this.dto.uso) {
      return '--';
    }
    let d = this.dto;
    return FormatUtils.buildRangeDescription(d.pesoMin, 'kg', d.pesoMax, 'kg');
  }

  getDescriptionAge() {
    if (!this.dto.uso) {
      return '--';
    }
    let d = this.dto;

    return FormatUtils.buildRangeDescription(
      d.idadeMin,
      this.getAgeTypeName(this.dto.idadeMinTipo),
      d.idadeMax,
      this.getAgeTypeName(this.dto.idadeMaxTipo)
    );
  }

  getAgeTypeName(selected) {
    if (!selected) {
      return null;
    }
    return new String(this.dto.tiposIdade.find((t) => t.id == selected).nome).toLowerCase();
  }

  getUnmaskedValue(v: string, mask) {
    return parseCurrency(v, mask);
  }

  getMaskedValue(v: number) {
    if (v == null) {
      return v;
    }
    return String(v).replace('.', ',');
  }

  onChange() {
    let val = { ...this.dto };
    val.pesoMin = this.dto.pesoMin ? this.getUnmaskedValue(this.dto.pesoMin, this.maskPeso) : null;
    val.pesoMax = this.dto.pesoMax ? this.getUnmaskedValue(this.dto.pesoMax, this.maskPeso) : null;

    this.$emit('input', val);
    this.$emit('change', val);
  }
}
